import { render } from "./VulnNoticeDetail.vue?vue&type=template&id=30c14d02"
import script from "./VulnNoticeDetail.vue?vue&type=script&lang=js"
export * from "./VulnNoticeDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__